export enum PaymentMethodCategory {
  Bank = 1,
  CreditCard = 2,
  Generic = 3,
  PaymentAgent = 4,
}

export const isPaymentProviderCategoryBank = (type?: PaymentMethodCategory) => {
  return type === PaymentMethodCategory.Bank
}
